module.exports = __webpack_public_path__ + "static/media/search.94704691.svg";